var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('HeaderNav'),_c('router-view'),_c('Footer'),_c('GoTopButton',{attrs:{"animate":true}},[_c('v-icon',[_vm._v(" mdi-arrow-up ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }